import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from './App';
import { store } from './store';

import './index.css';

import CustomToast from './components/Layout/SellerAgent/Negotiation/Component/customtoast';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <CustomToast />
      <App />
    </Provider>
  </React.StrictMode>
);
